import type {ChangeExpedientRepresentativeFormPayload} from "./change-expedient-representative.schema";
import {ChangeExpedientRepresentativeBody} from "@project/sdk/sales/zod";
import {changeExpedientRepresentative} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";
import {expedientKeys, expedientMutationKeys} from "../../../expedient-keys";

export function changeExpedientRepresentativeMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: expedientMutationKeys.changeExpedientRepresentative,
    mutationFn: (payload: ChangeExpedientRepresentativeFormPayload) =>
      changeExpedientRepresentative(id, ChangeExpedientRepresentativeBody.parse(payload)),
    onSuccess: async (_result, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: expedientKeys.detail(id)}),
        client.invalidateQueries({queryKey: expedientKeys.lists()}),
      ]);
    },
  });
}
